import React from "react";
import PropTypes from "prop-types";

//
import { useTable, useSortBy } from "react-table";

//
import ReactTable from "../../general/ReactTable";
import Moment from "react-moment";

function DesktopEventsList({ items }) {
  // begin::table
  const data = items;

  const columns = React.useMemo(
    () => [
      {
        Header: "name",
        accessor: "title",
        Cell: (cellProps) => {
          let value = cellProps.value;
          let source = cellProps.row.original.originalSource;

          return (
            <a target="_blank" href={source} className="fw-bolder title">
              {value}
            </a>
          );
        },
      },
      {
        Header: "Date start",
        accessor: "eventTime",
        Cell: (cellProps) => {
          let value = cellProps.value;

          return (
            <small className="date">
              <span className="fw-bolder">
                <Moment utc format="MMM DD, YYYY, ">{value}</Moment>
              </span>
              <span>
                <Moment utc format="hh:mm">{value}</Moment>
              </span>
            </small>
          );
        },
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data }, useSortBy);
  // end::table
  return (
    <ReactTable
      rows={rows}
      sticky
      bodySpace
      prepareRow={prepareRow}
      headerGroups={headerGroups}
      getTableProps={getTableProps}
      getTableBodyProps={getTableBodyProps}
    />
  );
}

DesktopEventsList.propTypes = {
  items: PropTypes.array.isRequired,
};

export default DesktopEventsList;
